import {fullDateTime} from '@management-ui/core';
import * as React from 'react';
import {useCallback, useContext, useMemo} from 'react';
import {ServiceContext} from '../../../../components/Services';
import {truncate} from '../../../../formatters';
import ManagementTable from '../../components/ManagementTable';
import JobTemplateForm from '../../forms/JobTemplateForm';

const JobTemplates = ({archive = false}) => {
  const services = useContext(ServiceContext);

  const handleDelete = useCallback(async (template) => services.jobTemplate.deleteTemplate(template.id), [services]);
  const handleRestore = useCallback(async (template) => services.jobTemplate.restoreTemplate(template.id), [services]);

  return (
    <ManagementTable
      title="Job Templates"
      addTitle={archive ? undefined : 'Add New Template'}
      editTitle={archive ? undefined : 'Edit Template'}
      columns={useMemo(() => [
        {title: 'Name', field: 'name'},
        {title: 'Title', field: 'title', render: data => data.title ?? '-'},
        {title: 'Description', field: 'description', render: data => truncate(data.description ?? '')},
        ...(archive ? [{title: 'Archived', field: 'deleted_at', render: data => fullDateTime(data.deleted_at)}] : [])
      ], [archive])}
      loadData={useCallback(async (query) => services.jobTemplate.getTableTemplates(query, archive ? {archive: 'only'} : {}), [services, archive])}
      onDelete={archive ? undefined : handleDelete}
      onRestore={archive ? handleRestore : undefined}
      renderForm={(props, template, onSaved) => (
        <JobTemplateForm
          {...props}
          template={template ?? {}}
          onSaved={onSaved}
        />
      )}
    />
  )
};

export default JobTemplates;
